import React, { createContext, useEffect, useRef } from "react";
import { useVersionedIndexedDBBackup } from "../../utils/useVersionedIndexedDbBackup";
import { DB_NAME, STORE_NAMES } from "../../App";

/* =======================================================
   Context
======================================================= */

const BackupContext = createContext({
  // backup: ...,
  subscribeToRestore: () => {},
  unsubscribeFromRestore: () => {},
});

/* =======================================================
   Provider
======================================================= */

export function BackupProvider({ children }) {
  const restoreListenersRef = useRef(new Set());
  // Patch useVersionedIndexedDBBackup to call listeners on restore
  const backup = useVersionedIndexedDBBackup(DB_NAME, STORE_NAMES, {
    onRestore: () => {
      restoreListenersRef.current.forEach(cb => {
        try { cb(); } catch (e) { console.error("Restore listener error", e); }
      });
    }
  });

  const subscribeToRestore = (cb) => {
    restoreListenersRef.current.add(cb);
    return () => restoreListenersRef.current.delete(cb);
  };
  const unsubscribeFromRestore = (cb) => {
    restoreListenersRef.current.delete(cb);
  };

  useEffect(() => {
    let mounted = true;

    async function initBackup() {
      await backup.loadBackupFile();

      if (!mounted) return;

      // // Prompt user only once ever
      // if (!backup.hasBackupFile && !backup.hasAskedToBackup()) {
      //   try {
      //     await backup.chooseBackupFile();
      //   } catch (error){
      //     console.error("User did not choose a backup file or encountered an error:", error);
      //     // user cancelled — do nothing
      //   }
      // }
    }

    initBackup();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <BackupContext.Provider value={{ ...backup, subscribeToRestore, unsubscribeFromRestore }}>
      {children}
    </BackupContext.Provider>
  );
}

/* =======================================================
   Class Component Support Helpers
======================================================= */

// Option A: Use contextType in class components
export { BackupContext };

// Option B: HOC if you prefer props injection
export function withBackup(Component) {
  return function WrappedComponent(props) {
    return (
      <BackupContext.Consumer>
        {backup => <Component {...props} backup={backup} />}
      </BackupContext.Consumer>
    );
  };
}